import { render } from "./Odak.vue?vue&type=template&id=7307d43e&scoped=true"
import script from "./Odak.vue?vue&type=script&lang=js"
export * from "./Odak.vue?vue&type=script&lang=js"

import "./Odak.vue?vue&type=style&index=0&id=7307d43e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7307d43e"]])

export default __exports__